import CircularProgress from "@mui/material/CircularProgress";

const Loader = (props) => {
  const { size = 15, style } = props;
  return <CircularProgress style={style} size={size} />;
};

export default Loader;
